export default __webpack_public_path__ + "static/media/TN1.5338de5f.png";